import styled, { css } from 'styled-components';

export const RedirectModalContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  border-top: 1px solid #f3f3f3;
  background: #fff;
  box-shadow: 8px -4px 16px 0px rgba(0, 0, 0, 0.12);
  z-index: 1;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding: 24px 32px;
    column-gap: 60px;
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    column-gap: 120px;
  }
`;

export const DisclaimerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  @media ${(props) => props.theme.mediaQuery.medium} {
    flex-direction: row;
    gap: 32px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    gap: 64px;
  }
`;

export const CustomButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 164px;
  height: 42px;
  padding: 8px 4px;
  cursor: pointer;
  border-radius: 6px;
  border: ${(props) => (props.primary ? 'none' : '1px solid #9B9B9B')};
  background-color: ${(props) => (props.primary ? '#003057' : 'transparent')};
  color: ${(props) => (props.primary ? '#fff' : '#000')};
  font-family: Nunito;
  text-align: center;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: 0.055px;
  text-transform: uppercase;

  @media ${(props) => props.theme.mediaQuery.medium} {
    min-width: 157px;
    height: 42px;
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    min-width: 268px;
    height: 50px;
    font-size: 14px;
    letter-spacing: 0.07px;
    line-height: 24px;
  }
`;

export const ButtonContainer = styled.span`
  height: 15px;
  width: 15px;
  min-height: 15px;
  min-width: 15px;
  cursor: pointer;
  margin-top: 3px;
  box-sizing: border-box;

  @media ${(props) => props.theme.mediaQuery.medium} {
    margin: 0;
    width: 36px;
    height: 36px;
    min-height: 36px;
    min-width: 36px;
    padding: 11px 10px 10px 11px;
  }
`;

export default css`
  .btn-wrapper {
    display: flex;
    column-gap: 13px;

    @media ${(props) => props.theme.mediaQuery.large} {
      column-gap: 24px;
    }
  }
  .disclaimer-text-container {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex;
      column-gap: 30px;
    }
  }
`;
